import {
  BooleanParam,
  StringParam,
  withDefault,
} from 'react-router-url-params';
import { SortOrder } from 'services/api/api-client.types';

export type InfiniteQueryOptions<T extends { totalCount: number }> = {
  lastPage: T;
  allPages: T[];
  pageSize: number;
};

export const getInfiniteQueryDefaults = <T extends { totalCount: number }>(
  options: InfiniteQueryOptions<T>,
): number | undefined => {
  const loaded = options.allPages.length * options.pageSize;
  if (loaded < options.lastPage.totalCount) {
    return options.allPages.length + 1;
  }
  return undefined;
};

export const defaultInitialPageParam = 1;

export const sortingQueryParams = (defaultDesc?: boolean) => ({
  sortBy: StringParam,
  desc: withDefault(BooleanParam, defaultDesc ?? false),
});
export function infiniteScrollingSortingToBackendRequest(query: {
  sortBy?: string | null;
  desc?: boolean;
}): {
  sortBy?: string | null;
  sortOrder?: SortOrder | undefined;
} {
  return {
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.desc ? SortOrder.Desc : SortOrder.Asc,
  };
}
